import config from '../../config';

export default {
  url: `${config.api.baseURL}/modules`,
  transformer(data) {
    return data;
  }
};
